import { useEffect, useRef } from 'react';
import dayjs from 'dayjs';
import filter from 'lodash/filter';

import { ForecastHourDetail } from 'hooks/useGetForecast';
import ForecastHour from './ForecastHour';
import ForecastHourLabels from './ForecastHourLabels';

type ForecastHourlyProps = {
  className?: string;
  hours?: ForecastHourDetail[];
};

function ForecastHourly({ className, hours }: ForecastHourlyProps) {
  const hoursRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (hoursRef.current) {
      hoursRef.current.scrollLeft = 0;
    }
  }, [hours]);

  if (hours) {
    const oneHourAgo = dayjs().subtract(1, 'hour');
    const filteredHours = filter(hours, (hour) => oneHourAgo.isBefore(dayjs(hour.time)));

    return (
      <div data-testid="forecast-hourly" className={className}>
        <div className="flex snap-x gap-2 overflow-x-auto" ref={hoursRef}>
          <ForecastHourLabels />
          {filteredHours.map((hour) => (
            <ForecastHour key={hour.time_epoch} hour={hour} />
          ))}
        </div>
      </div>
    );
  }

  return null;
}

export default ForecastHourly;
